module.exports = __webpack_public_path__ + "img/vision.87c5b8e4.png";